import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import './BookingReport.scss';
import DataTable from '../components/DataTables/datatable';
import API_URLS from '../summaryapi/apiUrls';
import { RingLoader } from 'react-spinners';

const BookingReport = () => {
    const [bookings, setBookings] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchBookings = async () => {
            try {
                setLoading(true);

                // Retrieve encoded IDs from session storage
                const encodedAdminId = sessionStorage.getItem('admin_id');
                const encodedProviderId = sessionStorage.getItem('provider_id');
                
                // Decode IDs if they exist
                const adminId = encodedAdminId ? atob(encodedAdminId) : null;
                const providerId = encodedProviderId ? atob(encodedProviderId) : null;

                // Determine the API URL based on user type
                const apiUrl = adminId 
                    ? API_URLS.getBookingReport.url  // Admin API URL
                    : API_URLS.providerBookingsHistoryReport.url;  // Provider API URL

                // Set up the API call based on the provider ID
                const options = adminId 
                    ? {} 
                    : { 
                        method: API_URLS.providerBookingsHistoryReport.method,
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ provider_id: providerId })
                    };

                const response = await fetch(apiUrl, options);

                if (!response.ok) {
                    throw new Error('Failed to fetch booking data');
                }

                const result = await response.json();
                if (result.status) {
                    setBookings(result.data);  // Assuming result.data contains the booking array
                } else {
                    toast.error('Error: ' + result.message);
                }
            } catch (error) {
                console.error('Error:', error);
                toast.error('An error occurred while fetching booking data.');
            } finally {
                setLoading(false);
            }
        };

        fetchBookings();
    }, []);
    if (loading) {
        return (
            <div>
                <h3 style={{color: '#8A2BE2'}}>Loading Booking Data...</h3>
                <RingLoader color="#3498db" loading={loading} size={50} />
            </div>
        );
    }
    // Define the columns for your data table based on the provided dummy data
    const columns = [
        { label: 'Booking Code', key: 'booking_code' },
        { label: 'User Name', key: 'user_name' },
        { label: 'Service Name', key: 'service_name' },
        { label: 'Booking Date', key: 'booking_date' },
        { label: 'Service Date', key: 'service_date' },
        { label: 'Service Time', key: 'service_time' },
        { label: 'Price', key: 'service_price' },
        { label: 'Status', key: 'status' },
    ];

    return (
        <div className="booking-report-container">
            <h3 className="page-heading" style={{color: '#8A2BE2'}}>Booking Report</h3>
            <DataTable data={bookings} columns={columns} />
        </div>
    );
};

export default BookingReport;
